const PageTitle = (props) => {
    return (
        <h3 className="pageTitle">{props.value}</h3>
    )
}

export default PageTitle;